{
  "AGENT_BOTS": {
    "HEADER": "Roboti",
    "LOADING_EDITOR": "Notiek redaktora ielāde...",
    "DESCRIPTION": "Aģenti Roboti ir kā pasakainākie jūsu komandas locekļi. Viņi var tikt galā ar sīkumiem, lai jūs varētu koncentrēties uz svarīgām lietām. Jūs varat pārvaldīt savus robotus šajā lapā vai izveidot jaunus, izmantojot pogu 'Konfigurēt jaunu robotu'.",
    "LEARN_MORE": "Uzzināt vairāk par aģentiem robotiem",
    "GLOBAL_BOT_BADGE": "Sistēma",
    "AVATAR": {
      "SUCCESS_DELETE": "Robota avatars veiksmīgi izdzēsts",
      "ERROR_DELETE": "Kļūda, dzēšot robota avataru, lūdzu, mēģiniet vēlreiz"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Robota nosaukums",
        "PLACEHOLDER": "Piešķiriet robotam nosaukumu.",
        "ERROR": "Jānorāda robota nosaukums."
      },
      "DESCRIPTION": {
        "LABEL": "Robota apraksts",
        "PLACEHOLDER": "Ko dara šis robots?"
      },
      "BOT_CONFIG": {
        "ERROR": "Lūdzu, ievadiet sava robota CSML konfigurāciju.",
        "API_ERROR": "Jūsu CSML konfigurācija nav derīga. Lūdzu, izlabojiet to un mēģiniet vēlreiz."
      },
      "SUBMIT": "Apstiprināt un saglabāt"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Izvēlieties aģentu robotu",
      "DESC": "Piešķiriet savai iesūtnei Aģentu Robotu. Viņi var apstrādāt sākotnējās sarunas un vajadzības gadījumā tās pārsūtīt tiešajam aģentam.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Atjaunināt",
      "DISCONNECT": "Atvienot robotu",
      "SUCCESS_MESSAGE": "Aģents robots ir veiksmīgi atjaunināts.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Aģenta robots ir veiksmīgi atvienots.",
      "ERROR_MESSAGE": "Nevarēja atjaunināt aģenta robotu. Lūdzu mēģiniet vēlreiz.",
      "DISCONNECTED_ERROR_MESSAGE": "Nevarēja atvienot aģenta robotu. Lūdzu mēģiniet vēlreiz.",
      "SELECT_PLACEHOLDER": "Izvēlieties robotu",
      "COUNTRY_BOTS": {
        "TITLE": "Roboti pēc valsts",
        "DESC": "Šī iesūtne apkalpo vairākas valstis. Saruna tiek nodota savas valsts robotam: pēc Kaufland veikala, Allegro pasūtījuma tirgus vietas vai, ja to nav, pēc valodas, kurā raksta klients. Visas pārējās sarunas tiek nodotas iepriekš norādītajam noklusējuma robotam.",
        "COUNTRY": "Izvēlieties valsti",
        "BOT": "Izvēlieties robotu",
        "ADD": "Pievienot valsts robotu",
        "REMOVE": "Noņemt",
        "DEFAULT_REQUIRED": "Vispirms izvēlieties noklusējuma robotu. Valsts robots to aizstāj tikai šai valstij.",
        "DISCONNECT_ALL": "Atvienot visus robotus"
      }
    },
    "ADD": {
      "TITLE": "Konfigurēt jaunu robotu",
      "CANCEL_BUTTON_TEXT": "Atcelt",
      "API": {
        "SUCCESS_MESSAGE": "Robots ir veiksmīgi pievienots.",
        "ERROR_MESSAGE": "Nevarēja pievienot robotu. Lūdzu, pamēģiniet vēlāk vēlreiz."
      }
    },
    "LIST": {
      "404": "Roboti nav atrasti. Jūs varat izveidot robotu, noklikšķinot uz 'Konfigurēt jaunu robotu' pogas ↗",
      "LOADING": "Notiek robotu iegūšana...",
      "TABLE_HEADER": {
        "DETAILS": "Robota informācija",
        "URL": "Webhook URL"
      },
      "TYPE": "Robota tips"
    },
    "DELETE": {
      "BUTTON_TEXT": "Dzēst",
      "TITLE": "Dzēst robotu",
      "CONFIRM": {
        "TITLE": "Apstiprināt Dzēšanu",
        "MESSAGE": "Vai tiešām vēlaties dzēst {name}?",
        "YES": "Jā, Dzēst",
        "NO": "Nē, Paturēt"
      },
      "SUBMIT": "Dzēst",
      "CANCEL_BUTTON_TEXT": "Atcelt",
      "DESCRIPTION": "Vai tiešām vēlaties dzēst šo robotu? Šī darbība ir neatgriezeniska.",
      "API": {
        "SUCCESS_MESSAGE": "Robots ir veiksmīgi izdzēsts.",
        "ERROR_MESSAGE": "Nevarēja izdzēst robotu. Lūdzu mēģiniet vēlreiz."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Rediģēt",
      "LOADING": "Notiek robotu iegūšana...",
      "TITLE": "Rediģēt robotu",
      "CANCEL_BUTTON_TEXT": "Atcelt",
      "API": {
        "SUCCESS_MESSAGE": "Robots ir veiksmīgi atjaunināts.",
        "ERROR_MESSAGE": "Nevarēja atjaunināt robotu. Lūdzu mēģiniet vēlreiz."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Robota avatars"
      },
      "NAME": {
        "LABEL": "Robota nosaukums",
        "PLACEHOLDER": "Ievadiet robota nosaukumu"
      },
      "DESCRIPTION": {
        "LABEL": "Apraksts",
        "PLACEHOLDER": "Ko dara šis robots?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook URL",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "Nepieciešams robota nosaukums",
        "URL": "Nepieciešams Webhook URL",
        "VALID_URL": "Lūdzu, ievadiet derīgu URL, kas sākas ar http:// vai https://"
      },
      "CANCEL": "Atcelt",
      "CREATE": "Izveidot Robotu",
      "UPDATE": "Atjaunināt Robotu"
    },
    "TYPES": {
      "WEBHOOK": "Webhook robots",
      "CSML": "CSML robots"
    }
  }
}
